import { Checkbox, CheckboxProps } from 'app/components/ui/Checkbox'
import { addErrorDataAttribute } from 'app/components/ui/ErrorFormScrollHandler'
import { FormFeedback } from 'app/components/ui/FormFeedback'
import React from 'react'
import { get, useFormContext } from 'react-hook-form'

export type SmartCheckboxProps = {
  name: string
  errorTextColor?: string
  onChange?: () => void
} & Omit<CheckboxProps, 'isChecked'>

export const SmartCheckbox = ({
  name,
  id,
  errorTextColor,
  onChange,
  children,
  ...rest
}: WithChildren<SmartCheckboxProps>): JSX.Element => {
  const {
    register,
    formState: { errors },
  } = useFormContext()

  const error = get(errors, name)

  const { onChange: onChangeRegister, ...registerProps } = register(name)

  return (
    <div>
      <Checkbox
        id={id ?? name}
        onChange={(e) => {
          // Calls react hook form onChange, needed for form to work
          onChangeRegister(e)

          // Calls custom onChange if present
          if (onChange) onChange()
        }}
        {...registerProps}
        {...rest}
        {...addErrorDataAttribute(!!error)}
      >
        {children}
      </Checkbox>
      {error ? (
        <FormFeedback customColor={errorTextColor} variant='error'>
          {error.message}
        </FormFeedback>
      ) : null}
    </div>
  )
}
